
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'

const PageConst= {
  ACTION: {
    doBrowse: { api: 'T2010TeacherBasicService.C40401_doBrowse_AtDataTable', input: {}},
    getStudentList: { api: 'T1010StudentBasicService.getStudentList', input: {}},
  },
}

const module = {
  state: {
    PageConst,

    studentList: [],

    C40401_ScheduleState:[]
  },

  getters: {},

  mutations: {},

  actions: {
    async init ({ state }) {
      const res = await $this.$api.postData({
        data: [
          PageConst.ACTION.getStudentList,
        ]
      })
      state.studentList = res[0].output
    },
    async C40401_getScheduleState ({state}){
      const res = await $this.$api.postData({ data: [
        {
          api: 'T3010ScheduleService.C40401_getScheduleState',
          input: state.searchInfo
        }
      ] })
      state.C40401_ScheduleState = res[0].output
      return res[0].output
    }
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
